
const config = {
    bankAccountLimit: 2,
}


export default config;